import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la sensación",
    opening: localizedGenderNode(
      [
      "Hoy no intento convencerme de lo contrario.",
      "Solo noto: siento que la vida pasó de largo.",
      "Estoy aquí."
    ],
      [
      "Hoy no intento convencerme de lo contrario.",
      "Solo noto: siento que la vida pasó de largo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo es especialmente fuerte esta sensación?",
      "¿Qué me digo en esos momentos?",
      "¿Qué siento en mi cuerpo?"
    ],
      [
      "¿Cuándo es especialmente fuerte esta sensación?",
      "¿Qué me digo en esos momentos?",
      "¿Qué siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La sensación es una experiencia, no soy yo."
    ],
      [
      "La sensación es una experiencia, no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración + \"Estoy aquí con la sensación\".",
      "una respiración + \"Estoy aquí con la sensación\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza la sensación.",
      "Solo noto.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto el momento en que empieza la sensación.",
      "Solo noto.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiración."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasa justo antes de que suba la sensación?",
      "¿Dónde me encuentra en el día?",
      "¿Qué intento evitar?"
    ],
      [
      "¿Qué pasa justo antes de que suba la sensación?",
      "¿Dónde me encuentra en el día?",
      "¿Qué intento evitar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cuando empieza.",
      "una respiración cuando empieza."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde siente mi cuerpo la sensación?",
      "¿Qué intenta proteger mi cuerpo?",
      "¿Qué podría suavizarse un poco?"
    ],
      [
      "¿Dónde siente mi cuerpo la sensación?",
      "¿Qué intenta proteger mi cuerpo?",
      "¿Qué podría suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta cuidarme."
    ],
      [
      "Mi cuerpo intenta cuidarme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiración.",
      "una mano en el pecho y una respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ],
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Lo que se apagó",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se apagó en mí.",
      "No para culpar.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto lo que se apagó en mí.",
      "No para culpar.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiración."
    ],
      [
      "Siento mis pies.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué suele faltarme?",
      "¿Cuándo me siento un poco más vivo/a?",
      "¿Qué extraño?"
    ],
      [
      "¿Qué suele faltarme?",
      "¿Cuándo me siento un poco más vivo/a?",
      "¿Qué extraño?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar lo que se apagó ya es un vínculo."
    ],
      [
      "Notar lo que se apagó ya es un vínculo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una cosa que extraño.",
      "escribir una cosa que extraño."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voz interna",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi voz interna.",
      "Sin forzar.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi voz interna.",
      "Sin forzar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué dice mi voz interna sobre esta sensación?",
      "¿Qué necesita esa voz de mí?",
      "¿Qué suena más suave dentro de mí?"
    ],
      [
      "¿Qué dice mi voz interna sobre esta sensación?",
      "¿Qué necesita esa voz de mí?",
      "¿Qué suena más suave dentro de mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz interna suave es un comienzo."
    ],
      [
      "Una voz interna suave es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna suave.",
      "una frase interna suave."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Una pequeña necesidad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad debajo de esta sensación.",
      "No resuelvo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad debajo de esta sensación.",
      "No resuelvo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito para sentirme un poco más vivo/a?",
      "¿Qué en mí pide calor o cercanía?",
      "¿Cómo se siente cuando me doy un momento?"
    ],
      [
      "¿Qué necesito para sentirme un poco más vivo/a?",
      "¿Qué en mí pide calor o cercanía?",
      "¿Cómo se siente cuando me doy un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Detrás de la sensación hay una petición."
    ],
      [
      "Detrás de la sensación hay una petición."
    ]
    ),
    action: localizedGenderNode(
      "escribir una petición para mí.",
      "escribir una petición para mí."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña conexión",
    opening: localizedGenderNode(
      [
      "Hoy busco una pequeña conexión dentro de mí.",
      "No grande, solo posible.",
      "Estoy aquí."
    ],
      [
      "Hoy busco una pequeña conexión dentro de mí.",
      "No grande, solo posible.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me da sensación de conexión ahora?",
      "¿Qué palabra me calma?",
      "¿Qué puedo darme por un momento?"
    ],
      [
      "¿Qué me da sensación de conexión ahora?",
      "¿Qué palabra me calma?",
      "¿Qué puedo darme por un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña conexión sigue siendo conexión."
    ],
      [
      "Una pequeña conexión sigue siendo conexión."
    ]
    ),
    action: localizedGenderNode(
      "una palabra tranquila en mi corazón.",
      "una palabra tranquila en mi corazón."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compasión hacia mí",
    opening: localizedGenderNode(
      [
      "Hoy me hablo con suavidad.",
      "No como un juez.",
      "Estoy aquí."
    ],
      [
      "Hoy me hablo con suavidad.",
      "No como un juez.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué puedo perdonarme?"
    ],
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué puedo perdonarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La suavidad no cancela la sensación."
    ],
      [
      "La suavidad no cancela la sensación."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición interna",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "No una exigencia, solo una petición.",
      "Estoy aquí."
    ],
      [
      "Hoy me doy una petición clara.",
      "No una exigencia, solo una petición.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ],
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede ayudarme a moverme."
    ],
      [
      "Una petición puede ayudarme a moverme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución, solo un paso pequeño.",
      "Me quedo conmigo."
    ],
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución, solo un paso pequeño.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ],
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar esta semana?",
      "¿Cuándo en el día es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ],
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar esta semana?",
      "¿Cuándo en el día es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño cambio es un comienzo real."
    ],
      [
      "Un pequeño cambio es un comienzo real."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para probarlo.",
      "elegir un momento para probarlo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Elegir presencia",
    opening: localizedGenderNode(
      [
      "Hoy reviso el momento de elección.",
      "Entre desaparecer y presencia.",
      "Estoy aquí."
    ],
      [
      "Hoy reviso el momento de elección.",
      "Entre desaparecer y presencia.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Escucho mi respiración.",
      "Una respiración."
    ],
      [
      "Escucho mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué elijo cuando siento que la vida pasó de largo?",
      "¿Qué pequeña elección de presencia es posible para mí?",
      "¿Cómo me siento después de esa elección?"
    ],
      [
      "¿Qué elijo cuando siento que la vida pasó de largo?",
      "¿Qué pequeña elección de presencia es posible para mí?",
      "¿Cómo me siento después de esa elección?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña elección cambia la dirección."
    ],
      [
      "Una pequeña elección cambia la dirección."
    ]
    ),
    action: localizedGenderNode(
      "decir en mi corazón \"Elijo estar aquí\" una vez.",
      "decir en mi corazón \"Elijo estar aquí\" una vez."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña dirección",
    opening: localizedGenderNode(
      [
      "Hoy noto hacia dónde quiero moverme.",
      "No lejos, solo una pequeña dirección.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto hacia dónde quiero moverme.",
      "No lejos, solo una pequeña dirección.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué quiero sentir más en la vida?",
      "¿Qué pequeño valor quiero vivir hoy?",
      "¿Qué pequeña señal muestra que está ocurriendo?"
    ],
      [
      "¿Qué quiero sentir más en la vida?",
      "¿Qué pequeño valor quiero vivir hoy?",
      "¿Qué pequeña señal muestra que está ocurriendo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una dirección suave es suficiente para empezar."
    ],
      [
      "Una dirección suave es suficiente para empezar."
    ]
    ),
    action: localizedGenderNode(
      "una frase corta de valor.",
      "una frase corta de valor."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta sensación?",
      "¿Cuál es la señal temprana de que estoy entrando en ella?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ],
      [
      "¿Qué aprendí sobre esta sensación?",
      "¿Cuál es la señal temprana de que estoy entrando en ella?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "No tengo que borrar la sensación para estar presente."
    ],
      [
      "No tengo que borrar la sensación para estar presente."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
].map(buildNormalizedDay);

export const theFeelingOfLifePassedMeByBlueprintEs = buildNormalizedPilotBlueprint({
  id: "the_feeling_of_life_passed_me_by_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "the_feeling_of_life_passed_me_by",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "תחושה שהחיים עברו לידי",
    en: "The feeling that life passed me by",
    es: "La sensación de que la vida pasó de largo",
  },
  days,
});

export default theFeelingOfLifePassedMeByBlueprintEs;
